import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from "history"
import { CircularProgress } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { index } from './store/actions/app.action'

const Auth = lazy(() => import('./view/auth'))
const Users = lazy(() => import('./view/desktop/users'))
const Accounts = lazy(() => import('./view/desktop/accounts'))
const Shopping = lazy(() => import('./view/desktop/shopping'))
const Actions = lazy(() => import('./view/desktop/actions'))
const Closed = lazy(() => import('./view/desktop/actions/closed'))
const Trash = lazy(() => import('./view/desktop/actions/trash'))
const EditAction = lazy(() => import('./view/desktop/actions/edit'))
const RaffleAction = lazy(() => import('./view/desktop/actions/raffle'))
const Consult = lazy(() => import('./view/desktop/consult'))
const Metrics = lazy(() => import('./view/desktop/metrics'))
const Transactions = lazy(() => import('./view/desktop/transactions'))
const Password = lazy(() => import('./view/desktop/password'))

const Routes = () => {
    const history = createBrowserHistory()
    const [loading, setLoading] = React.useState(true)
    const dispatch = useDispatch()

    React.useEffect(() => {
        if(history.location.pathname !== '/login') {
            dispatch(index()).then(res => res && setLoading(false))
        }else {
            setLoading(false)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
        {(history.location.pathname !== '/login' && loading ) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
        <Router>
            <Suspense fallback={<div className="d-flex justify-content-center align-items-center min-vh-100"> <CircularProgress/> </div>}>
                <Switch>
                    <Route exact path="/consult/:action_id" component={Consult} />
                    <Route exact path="/links/:action_id/:link_id/transactions" component={Transactions} />
                    <Route exact path="/links/:action_id/:link_id/metrics" component={Metrics} />
                    <Route exact path="/action/create" component={EditAction} />
                    <Route exact path="/action/:action_id/edit" component={EditAction} />
                    <Route exact path="/action/:action_id/raffle" component={RaffleAction} />
                    <Route exact path="/action/:action_id/metrics" component={Metrics} />
                    <Route exact path="/action/:action_id/transactions" component={Transactions} />
					<Route exact path="/actions/closed" component={Closed} />
                    <Route exact path="/actions/trash" component={Trash} />
                    <Route exact path="/actions" component={Actions} />
                    <Route exact path="/shopping/:user_id/transactions/:action_id" component={Transactions} />
                    <Route exact path="/shopping/:user_id" component={Shopping} />
                    <Route exact path="/gateway-payment" component={Accounts} />
                    <Route exact path="/supporters" component={Users} />
                    <Route exact path="/password" component={Password} />
                    <Route exact path="/login" component={Auth} />
                    <Route exact path="/" component={Actions} />
                </Switch>
            </Suspense>
        </Router>
        }
        </>
    )
}

export default Routes;